module.exports = __webpack_public_path__ + "archicons.7b70f56daf27a55bcab5.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/fonts/archicons.eot?3l3b66
// module id = ../../../../../src/fonts/archicons.eot?3l3b66
// module chunks = styles